<template>
  <control
    class="group-container"
    :label="label"
    :showClear="isSelected"
    @clear="onClear"
    :warning="warning"
  >
    <a-radio-group v-if="!multiple" :value="defaultValue" @change="onChange" class="section-group">
      <a-radio-button
        v-a11y-tab:outer-shadow
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        :class="option.itemClass"
      >{{ option.label }}</a-radio-button>

      <slot />
    </a-radio-group>

    <r-checkbox-group
      v-else
      :name="name"
      :value="defaultValue"
      @change="onChange"
      class="section-group"
    >
      <r-checkbox-wrapper>
        <r-checkbox-button
          v-a11y-tab:outer-shadow
          v-for="option in options"
          :key="option.value"
          :value="option.value"
          :class="option.itemClass"
        >{{ option.label }}</r-checkbox-button>
      </r-checkbox-wrapper>

      <r-checkbox-wrapper>
        <slot />
      </r-checkbox-wrapper>
    </r-checkbox-group>
  </control>
</template>

<script>
import Control from '@/components/account/targetingInfo/Control.vue';
import RCheckboxGroup from '@/components/common/CheckboxGroup.vue';
import RCheckboxButton from '@/components/common/CheckboxButton.vue';
import RCheckboxWrapper from '@/components/common/CheckboxWrapper.vue';

export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    defaultValue: undefined,
    label: String,
    warning: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    name: String,
  },
  components: {
    Control,
    RCheckboxGroup,
    RCheckboxButton,
    RCheckboxWrapper,
  },
  computed: {
    isSelected() {
      return !this.warning;
    },
  },
  methods: {
    onChange(e) {
      this.$emit('change', e);
    },
    onClear() {
      this.$emit('clear');
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/colors.scss';

.group-container .section-group.ant-radio-group {
  margin: -5px;

  .ant-radio-button-wrapper {
    border-radius: 4px !important;
    margin: 5px;
    height: auto;
    color: $text-grey;
  }

  .ant-radio-button-wrapper-checked {
    color: $primary;
  }

  .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-checked) {
    border: 1px solid #d9d9d9 !important;
  }

  .ant-radio-button-wrapper:not(:first-child)::before {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.group-container {
  flex-direction: column;
}
</style>
